import { Bell, AlertTriangle, Siren, type LucideIcon } from "lucide-react";

export type AlertTier = "notification" | "alert" | "urgent";

export const tierMeta: Record<AlertTier, {
  label: string;
  icon: LucideIcon;
  emoji: string;
  banner: string;
  badge: string;
  iconColor: string;
}> = {
  notification: {
    label: "Notis",
    icon: Bell,
    emoji: "🔔",
    banner:
      "bg-blue-50 border-blue-300 text-blue-900 dark:bg-blue-950/40 dark:border-blue-800 dark:text-blue-100",
    badge: "bg-blue-100 text-blue-800 border-blue-300 dark:bg-blue-900/50 dark:text-blue-100",
    iconColor: "text-blue-600 dark:text-blue-300",
  },
  alert: {
    label: "Varning",
    icon: AlertTriangle,
    emoji: "⚠️",
    banner:
      "bg-yellow-50 border-yellow-300 text-yellow-900 dark:bg-yellow-950/40 dark:border-yellow-800 dark:text-yellow-100",
    badge:
      "bg-yellow-100 text-yellow-800 border-yellow-300 dark:bg-yellow-900/50 dark:text-yellow-100",
    iconColor: "text-yellow-600 dark:text-yellow-300",
  },
  urgent: {
    label: "Akut",
    icon: Siren,
    emoji: "🚨",
    banner:
      "bg-[#CE2029]/90 border-[#CE2029] text-white dark:bg-[#CE2029]/90 dark:border-[#CE2029] dark:text-white",
    badge: "bg-[#CE2029] text-white border-[#CE2029] dark:bg-[#CE2029] dark:text-white",
    iconColor: "text-white dark:text-white",
  },
};

/**
 * Match a route path pattern (with :params) to the actual location pathname.
 */
export function pathMatches(pattern: string, pathname: string): boolean {
  const regex = new RegExp(
    "^" + pattern.replace(/:[^/]+/g, "[^/]+").replace(/\//g, "\\/") + "$",
  );
  return regex.test(pathname);
}
